import {ILabels, ILanguage} from "@/apps/StudentExchangeNonPartnerWidget/models/config-viewmodel";
import {ExchangeType} from "@/apps/StudentExchangeOverviewWidget/models/exchanges-viewmodel";
import {ButtonType} from "@/apps/StudentExchangeOverviewWidget/models/shared-viewmodel";

export interface Period {
    completed: boolean
    start: string
    end: string
    reason: string
}

export interface Contact {
    completed: boolean
    name: string
    email: string
}

export interface Institution {
    completed: boolean
    name: string
    city: string
    country: string
}

export interface Insurance {
    completed: boolean
    agreement: boolean
}

export interface ExchangeAction {
    action: ButtonType
    type: ExchangeType
    programOfStudyId: number
    academicYearId: string
    exchangeId: string
}

export interface StudentExchangeNonPartnerWidget {
    loading: boolean
    canContinue: boolean
    isSubmitted: boolean
    periodIsInvalid: boolean
    contactIsInvalid: boolean
    period: Period
    contact: Contact
    institution: Institution
    insurance: Insurance
    language: ILanguage
    programId: null | number
    exchangeId: null | string
    academicYearId: null | number
    studyName: null | string
    errorMessage: null | string
    labels: ILabels
}

export class WidgetState implements StudentExchangeNonPartnerWidget {
    loading: boolean = false
    editable: boolean = true
    cancelable: boolean = false
    canContinue: boolean = false
    isSubmitted: boolean = false
    periodIsInvalid: boolean = false
    contactIsInvalid: boolean = false
    period: Period = {
        completed: false,
        start: '',
        end: '',
        reason: ''
    }
    contact: Contact = {
        completed: false,
        name: '',
        email: ''
    }
    institution: Institution = {
        completed: false,
        name: '',
        city: '',
        country: '',
    }
    insurance: Insurance = {
        completed: false,
        agreement: false,
    }
    language: ILanguage = ''
    programId: null | number = null
    exchangeId: null | string = null
    academicYearId: null | number = null
    studyName: null | string = null
    errorMessage: null | string = null
    labels: ILabels = {
        programOfStudyPageTitle: '',
        programOfStudyBlockTitle: '',
        periodBlockTitle: '',
        periodFromDate: '',
        periodEndDate: '',
        periodTitle: '',
        periodText: '',
        reasonForStay: '',
        contactBlockTitle: '',
        contactName: '',
        contactEmail: '',
        contactInformationTitle: '',
        contactInformationText: '',
        nonPartnerBlockTitle: '',
        nonPartnerName: '',
        nonPartnerCity: '',
        nonPartnerCountry: '',
        nonPartnerTitle: '',
        nonPartnerText: '',
        crisisManagementHealthInsuranceAgreementBlockTitle: '',
        crisisManagementHealthInsuranceAgreement: '',
        crisisManagementHealthInsuranceAgreementTitle: '',
        crisisManagementHealthInsuranceAgreementText: '',
        submitBlockTitle: '',
        submitButton: '',
        countries: [],
        mobilityTypes: [],
        invalidDateInputErrorMessage: '',
        invalidEmailInputErrorMessage: '',
        exchangeSubmissionCompletionTitle: '',
        exchangeSubmissionCompletionText: '',
        exchangeSubmissionCompletionButton: '',
        exchangeSubmissionErrorMessage: ''
    }
}
